import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthenticatedUserRepositoryService } from '../../../services/authenticated-user-repository.service';
import { AddressModel } from '../../../../shared/models/address.model';
import { DeliveryStepsService } from '../../../services/delivery-steps.service';

@Component({
    selector: 'payment-delivery-addresses-ready',
    templateUrl: './payment.delivery.addresses.ready.component.html'
})
export class PaymentDeliveryAddressesReadyComponent {
    public flagUpdateSelectedAddress = false;
    @Input() address: AddressModel;
    @Output() updatingSelectedAddress: EventEmitter<null> = new EventEmitter();
    @Output() updatedSelectedAddress: EventEmitter<AddressModel> = new EventEmitter();
    @Output() selectedAddressReseted: EventEmitter<null> = new EventEmitter();

    constructor(
        protected deliverySteps: DeliveryStepsService,
        protected authenticatedUserService: AuthenticatedUserRepositoryService
    ) {
        this.authenticatedUserService.resetedUser$.subscribe(() => {
            this.flagUpdateSelectedAddress = false;
        });
        this.deliverySteps.selectedFreight$.subscribe(() => {
            this.flagUpdateSelectedAddress = false;
        });
    }

    /**
     * This update current selected address from service and set true on flag to
     * open update selected address data.
     **/
    public updateSelectedAddressInfo(): void {
        this.flagUpdateSelectedAddress = true;
        this.updatingSelectedAddress.emit(null);
    }
    /**
     * This set false to update select address data flag.
     **/
    public addressUpdated(address: AddressModel): void {
        this.deliverySteps.setSelectedAddress(address);
        this.deliverySteps.resetFreights();
        this.flagUpdateSelectedAddress = false;
        this.updatedSelectedAddress.emit(address);
    }
    /**
     * This reset selected address option and trigger event.
     * */
    public resetSelectedAddress(): void {
        this.deliverySteps.resetSelectedAddress();
        this.selectedAddressReseted.emit(null);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/payment/delivery/addresses/ready/payment.delivery.addresses.ready.component.ts